import React, { useEffect, useState } from 'react';
const ScrollIndicator = () => {
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollX > 50) {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-8 right-8 z-20 animate-pulse hidden md:block" data-id="element-661" data-mp="dq2og59j9z1h">
      <div className="flex items-center text-[#333333] opacity-70 hover:opacity-100 transition-opacity" data-id="element-662" data-mp="8pf05rcovway">
        <span className="mr-2 text-sm" data-id="element-663" data-mp="3wlr4ra6u1t2">Scroll horizontally</span>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-664" data-mp="3v59etdvwi13s">
          <line x1="5" y1="12" x2="19" y2="12" data-id="element-665" data-mp="rmg376monmc9"></line>
          <polyline points="12 5 19 12 12 19" data-id="element-666" data-mp="1qavj7syekoyo"></polyline>
        </svg>
      </div>
    </div>;
};
export default ScrollIndicator;